import { SpaceValues } from "@/lib/utils/SpaceValues";
import { Column, Row, Space, Txt } from "@stenajs-webui/core";
import { formatPeriod, formatRebateTerm } from "../../lib/formatter";
import { getActiveGoal, getCriteriaNames } from "../../lib/rebateOverviewUtils";
import { RebateBookingsOverview } from "../../types/types";

interface Props {
  rebate: RebateBookingsOverview;
}

export const RebateBookingsSummary = ({ rebate }: Props) => {
  const activeGoal = getActiveGoal(rebate);

  return (
    <Column>
      <Row alignItems={"center"}>
        <Txt variant={"bold"}>{rebate.rebateAgreement?.name ?? ""}</Txt>
        <Space num={SpaceValues.SIXTEEN} />
        <Txt>{formatRebateTerm(rebate.rebateTermCode)}</Txt>
      </Row>

      <Space num={SpaceValues.SIXTEEN} />

      <Row alignItems={"center"}>
        <Txt>{getCriteriaNames(rebate)}</Txt>
        <Space num={SpaceValues.SIXTEEN} />
        <Txt>
          {formatPeriod(
            rebate.period,
            rebate.rebateTermCode,
            activeGoal?.validFrom
          )}
        </Txt>
      </Row>
    </Column>
  );
};
